import {hot} from "react-hot-loader/root";
import React, {Component} from "react";
import { withRouter} from "react-router-dom";
import _ from "lodash";
import {Spin} from "antd";

import Layout from "./../containers/LayoutContainer";
import connect from "react-redux/es/connect/connect";
import {
    authGetUpsellTokenFromGoogle,
    authGetCurrentUserInfos,
    setAuthToken,
    authGetUpsellTokenFromMicrosoft
} from "./../redux/actions/authActions";
import {setCurrentClient} from "redux/actions/authActions";
import {FormattedMessage} from "react-intl";
import Login from "./login";


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogout: localStorage.access_token ? false : true,
            isGapiClientLoading: true
        };
    }

    // This is a variable which doesn't need to be in the state
    //GoogleAuth;

    componentDidMount() {
        // if (localStorage.access_token)
        const token = localStorage.getItem("access_token");

        if (token) this.props.setAuthToken(token);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.token !== this.props.token) {
            this.props.token.trim() !== "" ? this.props.authGetCurrentUserInfos() : this.setState({isLogout: true});
        } else if (prevProps.userInfos !== this.props.userInfos) {
            if (!_.isEmpty(this.props.userInfos) && !_.isEmpty(this.props.userInfos.clients)) {
                localStorage.currentClient
                    ? this.props.setCurrentClient(JSON.parse(localStorage.getItem("currentClient")))
                    : this.props.setCurrentClient(this.props.userInfos.clients[0]);
                this.setState({
                    isGapiClientLoading: false,
                    isLogout: false
                });
            }
        }
    }

    // Sign up
    handleAuthClickGoogle = (data) => {
        const jwtToken = data.credential;
        this.props.authGetUpsellTokenFromGoogle(jwtToken);
    };
    handleAuthClickMicrosoft = (data) => {
        const jwtToken = data.accessToken;
        const account = data.account || {};
        const username = account.username || ""; // it's actually the email ?
        this.props.authGetUpsellTokenFromMicrosoft(jwtToken, username);
    };

    // Log out
    revokeAccess = () => {
        this.setState({
            isLogout: true
        });
    };

    render() {
        const localHost = window.location.hostname;
        
        return (
          <React.Fragment>
            {this.state.isLogout && (
              <Login
                handleAuthClickGoogle={this.handleAuthClickGoogle}
                handleAuthClickMicrosoft={this.handleAuthClickMicrosoft}
              />
            )}

            {this.state.isGapiClientLoading && (
              <div
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  marginBottom: "20px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%"
                  }}
                >
                  <Spin size="large" />
                  <p
                    style={{
                      margin: "0 0 0 20px",
                      padding: 0,
                      fontWeight: "600",
                      fontSize: "24px"
                    }}
                  >
                    {
                      <FormattedMessage id={"Chargement"} defaultMessage={"Chargement"}>
                        {txt => <React.Fragment>{txt}</React.Fragment>}
                      </FormattedMessage>
                    }
                    ...
                  </p>
                </div>
              </div>
            )}
            {!this.state.isGapiClientLoading && (
              <Layout
                {...this.props}
                stateUser={this.props.googleData}
                loggout={function() {
                  this.revokeAccess();
                }}
              />
            )}
          </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userInfos: state.userInfos,
        token: state.auth.token,
        logged: state.auth.logged,
        googleData: state.auth.googleData,
        googleLogged: state.auth.googleLogged,
        googleScopesGranted: state.auth.googleScopesGranted
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        authGetUpsellTokenFromGoogle: token => {
            dispatch(authGetUpsellTokenFromGoogle(token));
        },
        authGetUpsellTokenFromMicrosoft: (token, username) => {
            dispatch(authGetUpsellTokenFromMicrosoft(token, username));
        },
        authGetCurrentUserInfos: () => dispatch(authGetCurrentUserInfos()),
        setAuthToken: token => dispatch(setAuthToken(token)),
        setCurrentClient: clientInfos => dispatch(setCurrentClient(clientInfos))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(hot(App)));



// WEBPACK FOOTER //
// src/components/App.js